import { Text, View } from "react-native";

import { CircularProgress } from "@mui/material";
import { ImageLoading } from "../../../../common/component";
import React from "react";

function loader({
  fullPageLoader,
  styles,
  message,
}: {
  fullPageLoader?: boolean;
  styles: any;
  message: string;
}): JSX.Element {
  return (
    <View style={styles}>
      <ImageLoading />
      {message ? (
        <Text style={{ position: "absolute", marginTop: "7vw" }}>
          {message}
        </Text>
      ) : null}
    </View>
  );
}

export default loader;
